import { gql } from "@apollo/client";

const AdminToggleMutation = gql`
  mutation AdminToggle($userId: UUID!, $admin: Boolean!) {
    updateUserByAppId(
      input: { userPatch: { isAdmin: $admin }, appId: $userId }
    ) {
      user {
        isAdmin
      }
    }
  }
`;

const hash = "d93095385d3affe2624645b2dc5017d6d19b0c7b6934911220e943bb381e7378";

export { AdminToggleMutation, hash };
